<template>
    <v-container>
        <v-tooltip top>
            <v-btn
                    class="mr-2 mb-2"
                    @click="newGeoFence"
                    color="customPurple"
                    dark
                    fixed
                    bottom
                    right
                    fab
                    slot="activator"
            >
                <v-icon>add</v-icon>
            </v-btn>
            <span>Crear GeoCerca</span>
        </v-tooltip>
        <v-data-table
                :headers="headers3"
                :items="this.geoFences"
                :search="search"
                class="elevation-1"
                sort-icon="mdi-menu-down"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left"><img :src="props.item.device.image" width="40px"></td>
                <td class="text-xs-left">{{ props.item.geoFenceName }}</td>
                <td class="text-xs-left">{{ props.item.geoFenceDescription }}</td>
                <td class="text-xs-left">{{ props.item.device.name }}</td>
                <td class="text-xs-left">{{ props.item.device.imei }}</td>
                <td class="text-xs-left">
                  <v-layout>
                    <v-flex xs12 sm10 offset-sm1>
                      <v-switch
                          label="Inactivo / Activo"
                          v-model="props.item.status"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </td>
              <td>
                    <v-tooltip top>
                        <v-btn fab small @click="editGeoFence(props.item)" slot="activator" color="white">
                            <img src="../../assets/Editar fondo.png" width="40px"/>
                        </v-btn>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn fab small @click="deleteItem(props.item)" slot="activator" color="white">
                            <img src="../../assets/Eliminar fondo.png" width="40px"/>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
        <v-dialog
                v-model="dialogGeo"
                fullscreen
                transition="dialog-bottom-transition"
                scrollable>
            <v-card tile>
                <v-toolbar card dark color="nav_background_color">
                    <v-btn icon dark @click.native="dialogGeo = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Geocerca</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <div class="column" style="width: 25%;float: left;">
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-autocomplete
                                v-model="geoFence.device"
                                :items="this.devices"
                                item-value="id"
                                item-text="name"
                                label="Dispositivo"
                                @change="selectedItemMapGeoFence"
                                return-object
                                persistent-hint
                                required
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-select
                                :items="types"
                                v-model="geoFence.type"
                                label="Tipo de geocerca"
                                hint="Tipo de geocerca"
                                return-object
                                :rules="[v => !!v || 'El tipo de Reporte es requerido']"
                                required
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-slider
                                v-if="geoFence.type=='CIRCUNFERENCIA'"
                                v-model="geoFence.radious"
                                :thumb-size="40"
                                :max="5000"
                                :min="100"
                                :step="100"
                                thumb-label="always"
                            ></v-slider>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-text-field
                                name="nombre"
                                label="Nombre"
                                id="nombreFence"
                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                v-model="geoFence.geoFenceName"
                                required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-textarea
                                name="description"
                                label="Descripción"
                                id="description"
                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 500) || 'El número de caracteres debe ser menor a 500']"
                                v-model="geoFence.geoFenceDescription"
                                required
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm10 offset-sm1>
                            <v-switch
                                label="Inactivo / Activo"
                                v-model="geoFence.status"
                            ></v-switch>
                          </v-flex>
                        </v-layout>
                        <br>
                        <br>
                        <v-layout>
                          <v-flex class="text-xs-center">
                            <v-btn @click="saveGeoFence" large color="primary">Guardar</v-btn>
                            <v-btn @click="dialogGeo = false" large color="primary">Cerrar</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="column" style="width: 75%;height: 100%; float: right">
                        <GmapMap
                            ref="map"
                            :center="this.geoFence.positionDevice==''?{lat:-0.190029, lng:-78.482114}:this.geoFence.positionDevice.position"
                            :zoom="14"
                            map-type-id="terrain"
                            style="width: 100%; height:92vh;"
                            @click='mark'
                        >
                          <GmapMarker
                              :position="geoFence.positionDevice.position"
                              :clickable="true"
                              @click="center=this.geoFence.positionDevice.position"
                              :icon="this.geoFence.positionDevice.icon"
                          />
                          <GmapCircle
                              ref="circle"
                              v-if="geoFence.position!=''"
                              :center="geoFence.position"
                              :position.sync="geoFence.position"
                              :radius="geoFence.radious"
                              :visible="true"
                              :options="{fillColor:'blue',fillOpacity:0.25}"
                              :clickable="true"
                              :draggable="true"
                              @dragend="centerChanged($event)"
                          ></GmapCircle>
                          <GmapRectangle
                              ref="rectangle"
                              v-if="geoFence.position!=''"
                              :center="geoFence.position"
                              :position.sync="geoFence.position"
                              :radius="geoFence.radious"
                              :visible="true"
                              :options="{fillColor:'blue',fillOpacity:0.25}"
                              :clickable="true"
                              :draggable="true"
                              @dragend="centerChanged($event)"
                          ></GmapRectangle>
                          <gmap-polygon v-if="geoFence.paths" :paths="geoFence.paths" :editable="true" @paths_changed="updateEdited($event)"
                                        @rightclick="handleClickForDelete"
                                        ref="polygon">
                          </gmap-polygon>
                        </GmapMap>
                      </div>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import Device from '../../model/Device';

    export default {
        watch: {

        },
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                markersGeoFence: [],
                headers3: [
                    {text: 'Avatar', value: 'avatar'},
                    {text: 'Nombre de Geo Cerca', value: 'geoFenceName'},
                    {text: 'Descripción', value: 'geoFenceDescription'},
                    {text: 'Dispositivo', value: 'device.name'},
                    {text: 'Imei', value: 'device.imei'},
                  {text: 'Estado', value: 'device.status'},
                  {text: 'Acciones', value: 'actions'}
                ],
                editedIndex: -1,
                date: "",
                menu: false,
                geoFenceObject: {id: "", value: "", date: new Date()},
                active: 0,
                dialogGeo: false,
                geoFence: {
                    id: "",
                    geoFenceName: "",
                    geoFenceDescription: "",
                    device: "",
                    position: "",
                    radious: 500,
                    positionDevice: "",
                    paths:[]
                },
                geoFences: [],
                devices:[],
                center: {lat: -0.190029, lng: -78.48211},
                edited: null,
                paths: [
                ],
                mvcPaths: null,
                errorMessage: null,
                polygonGeojson: '',
                types: ["POLIGONO", "CIRCUNFERENCIA"],
                deviceTraccarObject:{}
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.device = new Device();
                this.valid = false;
                this.dialog = false;
            },
            newDevice() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.device = new Device();
            },

            reload() {
                let search = ""
                if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
                    search = this.$store.state.idUser
                } else {
                    search = this.$store.state.deviceUser.login
                }
                this.$store.dispatch('getDevicesByUserLogin', search).then(response => {
                    this.devices = []
                    this.geoFences = []
                    for (let i = 0; i < response.data.length; i++) {
                        let object = JSON.parse(response.data[i].value)
                        object.id = response.data[i].id
                        object.selected = false
                        object.user = response.data[i].user
                        this.devices.push(object)
                        this.$store.dispatch('getGeofencesByDevice', object.id).then(
                            response2 => {
                                for (let i = 0; i < response2.data.length; i++) {
                                  let device=JSON.parse(response2.data[i].userDevice.value)
                                  let geoFen = JSON.parse(response2.data[i].value)
                                  geoFen.device = device
                                  geoFen.positionDevice.icon = {
                                    url: device.image,
                                        size: {width: 80, height: 80, f: 'px', b: 'px'},
                                    scaledSize: {width: 60, height: 60, f: 'px', b: 'px'}
                                  }
                                  geoFen.id = response2.data[i].id
                                  this.geoFences.push(geoFen)
                                }
                            }
                        );

                    }
                })
            },
            mark(event) {
              if(this.geoFence.type=='POLIGONO'){
                this.addPath()
              }else{
                this.geoFence.position = {
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng(),
                }
              }
            },
          centerChanged(event) {
            this.geoFence.position = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            }

          },
            newGeoFence() {
                this.editedIndex = -1
                this.geoFence = {
                    id: "",
                    geoFenceName: "",
                    geoFenceDescription: "",
                    device: "",
                    position: "",
                    radious: 500,
                    positionDevice: ""
                }
                this.dialogGeo = true

            },
            editGeoFence(item) {

              this.editedIndex = this.geoFences.indexOf(item)
              this.geoFence = this.geoFences[this.editedIndex]
              this.dialogGeo = true
            },

            getArea(){
                if(this.geoFence.type=='CIRCUNFERENCIA'){
                  return "CIRCLE ("+this.geoFence.position.lat+" "+this.geoFence.position.lng+" , "+this.geoFence.radious+")"
                }else{
                  let data = "POLYGON ("
                  for (let i=0; i<this.geoFence.paths[0].length; i++) {
                    data = data +this.geoFence.paths[0][i].lat+" "+this.geoFence.paths[0][i].lng+" , "

                  }
                  data = data +")"

                  return "POLYGON ((-0.185463008690152 -78.49134222222222 , -0.2137869633115517 -78.53051449013603 , -0.2137869633115517 -78.4521699543084))"
                }
            },
            saveGeoFence() {
                if (this.$refs.form.validate()) {
                    this.geoFenceObject.id = this.geoFence.id
                    this.geoFenceObject.userDevice = this.geoFence.device
                    if (this.geoFenceObject.id != null && this.geoFenceObject.id != "") {
                      this.geoFenceObject.value = JSON.stringify(this.geoFence)
                      this.$store.dispatch('updateGeofence', this.geoFenceObject).then(
                            response => {
                              let geoFenceTraccarObject = {
                                "id":this.geoFence.idGeofenceTraccar,
                                "name": this.geoFence.geoFenceName,
                                "description": this.geoFence.geoFenceDescription,
                                "area": this.getArea(),
                                "calendarId": 0
                              }
                              this.$store.dispatch('updateGeofenceTraccar', geoFenceTraccarObject).then(
                                  responseTraccar => {
                                    this.reload();
                                  },
                                  error => {
                                    this.$store.state.progress = false;
                                    this.$store.state.dialogError = true;
                                  }
                              );
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.geoFenceObject.date = new Date()
                        this.geoFenceObject.userDevice = this.geoFence.device
                      let geoFenceTraccarObject = {
                        "name": this.geoFence.geoFenceName,
                        "description": this.geoFence.geoFenceDescription,
                        "area": this.getArea(),
                        "calendarId": 0
                      }
                      this.$store.dispatch('addGeofenceTraccar', geoFenceTraccarObject).then(
                          responseTraccar => {
                           this.geoFence.idGeofenceTraccar = responseTraccar.data.id
                           this.geoFenceObject.value = JSON.stringify(this.geoFence)
                            let data={
                              "deviceId": this.deviceTraccarObject.id,
                              "geofenceId": responseTraccar.data.id,
                            }
                            this.$store.dispatch('addGeofence', this.geoFenceObject).then(
                                response => {
                                  if(!response) {
                                    this.$store.state.progress = false;
                                    this.$store.state.dialogError = true;
                                    return
                                  }
                                  this.$store.dispatch('linkGeofenceTraccarToDevice', data).then(
                                      responseLinData => {
                                        this.reload();
                                      },
                                      error => {
                                        this.$store.state.progress = false;
                                        this.$store.state.dialogError = true;
                                      }
                                  );

                                },
                                error => {
                                  this.$store.state.progress = false;
                                  this.$store.state.dialogError = true;
                                }
                            );
                          },
                          error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                          }
                      );

                    }
                    this.dialogGeo = false;
                }
            },
            selectedItemMapGeoFence() {
                this.$store.dispatch('getDevicesLocationTraccar', this.geoFence.device.idTraccar).then(response => {
                  this.$store.dispatch('getDeviceTraccar', this.geoFence.device.idTraccar).then(
                      responseTraccar => {
                        this.deviceTraccarObject=responseTraccar.data
                      },
                      error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                      }
                  );
                    this.geoFence.positionDevice = {
                        // position: {
                        //     lat: -0.190029,
                        //     lng: -78.48211,
                        //     imei: this.geoFence.device.imei
                        // },
                        position: {
                            lat: response.data.result[0].lat,
                            lng: response.data.result[0].lng
                        },
                        icon: {
                            url: this.geoFence.device.image,
                            size: {width: 80, height: 80, f: 'px', b: 'px'},
                            scaledSize: {width: 60, height: 60, f: 'px', b: 'px'}
                        }
                    }
                })
            },
            deleteItem(item) {
              this.editedIndex = this.geoFences.indexOf(item);
              this.geoFence = Object.assign({}, item);

              if (confirm('Está seguro de que quiere eliminar el registro?')) {
                this.$store.dispatch('deleteGeofenceTraccar', this.geoFence.idGeofenceTraccar).then(
                    responseLinData => {
                      this.$store.dispatch('deleteGeofence', this.geoFence.id).then(response => {
                        this.reload()
                      })
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
                );
              }
            },
          updateCenter(place) {
            this.center = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            }
          },
          updateEdited(mvcPaths) {
            this.mvcPaths = mvcPaths
          },
          addPath() {
              this.geoFence.paths=[]
            // obtain the bounds, so we can guess how big the polygon should be
            var bounds = this.$refs.map.$mapObject.getBounds()
            var northEast = bounds.getNorthEast()
            var southWest = bounds.getSouthWest()
            var center = bounds.getCenter()
            var degree = this.geoFence.paths.length + 1;
            var f = Math.pow(0.66, degree)

            // Draw a triangle. Use f to control the size of the triangle.
            // i.e., every time we add a path, we reduce the size of the triangle
            var path = [
              { lng: center.lng(), lat: (1-f) * center.lat() + (f) * northEast.lat() },
              { lng: (1-f) * center.lng() + (f) * southWest.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() },
              { lng: (1-f) * center.lng() + (f) * northEast.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() },
            ]

            this.geoFence.paths.push(path)
          },
          removePath() {
            this.geoFence.paths.splice(this.geoFence.paths.length - 1, 1)
          },
          handleClickForDelete($event) {
            if ($event.vertex) {
              this.$refs.polygon.$polygonObject.getPaths()
                  .getAt($event.path)
                  .removeAt($event.vertex)
            }
          },
        },
          computed: {
            polygonPaths: function () {
              if (!this.mvcPaths) return null

              let paths = [];
              for (let i=0; i < this.mvcPaths.getLength(); i++) {
                let path = [];
                for (let j=0; j<this.mvcPaths.getAt(i).getLength(); j++) {
                  let point = this.mvcPaths.getAt(i).getAt(j);
                  path.push({lat: point.lat(), lng: point.lng()});
                }
                paths.push(path);
              }
              return paths
            },
          },
        created() {
            this.reload()
        },

    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/GeoFence.vue